var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCaretRight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5px",
    height: "8px",
    viewBox: "0 0 5 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "----\\u21B3-Overview",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4.0-Filter-Expenses",
    transform: "translate(-1082.000000, -604.000000)",
    fill: "#A6B6CC"
  }, /*#__PURE__*/React.createElement("g", {
    id: "page__main",
    transform: "translate(112.000000, 176.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "table",
    transform: "translate(0.000000, 320.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "table__body",
    transform: "translate(0.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "table__row",
    transform: "translate(0.000000, 48.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "budget",
    transform: "translate(936.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(24.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0940329,9.68006851 C12.3202368,9.43997002 12.6797283,9.43997002 12.9059322,9.68006851 L16.3364929,13.4358466 C16.4966541,13.6146845 16.5440278,13.8808257 16.4569238,14.1124178 C16.3698198,14.3440099 16.1650078,14.4964658 15.9362608,14.5000054 L9.07513948,14.5000054 C8.84431492,14.5014682 8.63531571,14.3508538 8.54529411,14.118153 C8.45527252,13.8854521 8.50188824,13.6163142 8.6634722,13.4358466 L12.0940329,9.68006851 Z",
    transform: "translate(12.500005, 12.000000) rotate(-270.000000) translate(-12.500005, -12.000000) "
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretRight);
export default __webpack_public_path__ + "static/media/caret-right.b4d9f2a272c75730c86c26a3494f47f3.svg";
export { ForwardRef as ReactComponent };